var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSa = function SvgSa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M6.783 14.348c0 .864.701 1.565 1.565 1.565h4.696c0 .72.584 1.304 1.304 1.304h1.566c.72 0 1.304-.584 1.304-1.304v-1.565H6.783ZM17.347 6.783v3.652c0 .576-.468 1.044-1.043 1.044v1.565a2.612 2.612 0 0 0 2.608-2.609V6.783h-1.565ZM6.13 10.435c0 .575-.468 1.043-1.043 1.043v1.566a2.612 2.612 0 0 0 2.609-2.609V6.783H6.13v3.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.565 6.783H15v3.652h1.565V6.783ZM12.652 8.87a.261.261 0 0 1-.521 0V6.783h-1.566V8.87a.261.261 0 0 1-.521 0V6.783H8.479V8.87c0 1.007.819 1.826 1.826 1.826.387 0 .747-.122 1.043-.329a1.816 1.816 0 0 0 1.274.314c-.11.457-.522.798-1.013.798v1.565a2.612 2.612 0 0 0 2.609-2.609V6.783h-1.566V8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M10.826 11.478H8.48v1.565h2.347v-1.565Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSa;